import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class AsyncTask {
  constructor(taskId, url, startTask, task, canceller) {
    _defineProperty(this, "_taskId", void 0);
    _defineProperty(this, "_url", void 0);
    _defineProperty(this, "startTask", void 0);
    _defineProperty(this, "task", void 0);
    _defineProperty(this, "isCanceled", void 0);
    _defineProperty(this, "pendingCancel", void 0);
    _defineProperty(this, "pendingCancelReject", void 0);
    _defineProperty(this, "canceller", void 0);
    _defineProperty(this, "callStack", void 0);
    this._taskId = taskId;
    this._url = url;
    this.startTask = startTask;
    this.task = new Promise((resolve, reject) => {
      startTask.then(launchResponse => {
        task(launchResponse).then(resolve, reject);
      }, reject);
    });
    this.isCanceled = false;
    this.pendingCancel = null;
    this.pendingCancelReject = null;
    this.canceller = canceller;
    this.callStack = new Error().stack;
  }
  launched() {
    return this.startTask.then();
  }
  result() {
    return this.task;
  }
  get canceled() {
    return this.isCanceled;
  }
  cancel() {
    if (this.isCanceled) {
      return Promise.resolve();
    }
    this.isCanceled = true;
    let cancelPromise = this.canceller.cancel(this._taskId);
    if (cancelPromise) {
      return cancelPromise;
    } else {
      return new Promise((resolve, reject) => {
        this.pendingCancel = resolve;
        this.pendingCancelReject = reject;
      });
    }
  }
  fulfillCancel(cancelInvoker) {
    cancelInvoker(this._taskId).then(() => {
      if (this.pendingCancel) {
        this.pendingCancel();
      }
    }).catch(error => {
      if (this.pendingCancelReject) {
        this.pendingCancelReject(error);
      }
    });
  }
  get taskId() {
    return this._taskId;
  }
  get url() {
    return this._url;
  }
}
//# sourceMappingURL=AsyncTask.js.map
